"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarChartShark = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var React = __importStar(require("react"));
var recharts_1 = require("recharts");
var CustomTick_1 = require("./CustomTick");
var CustomTooltip_1 = require("./CustomTooltip");
require("./barChart.css");
var BarChartShark = /** @class */ (function (_super) {
    __extends(BarChartShark, _super);
    function BarChartShark() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderVerticalBarChart = function () { return ((0, jsx_runtime_1.jsx)(recharts_1.ResponsiveContainer, __assign({ width: "100%", height: _this.props.chartHeight, className: "bar-chart" }, { children: (0, jsx_runtime_1.jsxs)(recharts_1.BarChart, __assign({ layout: "vertical", data: _this.props.data }, { children: [(0, jsx_runtime_1.jsx)(recharts_1.CartesianGrid, { horizontal: false, stroke: BarChartShark.COLOR_VERY_DARK_GREY }), (0, jsx_runtime_1.jsx)(recharts_1.XAxis, { type: "number", interval: _this.props.xAxisInterval, stroke: BarChartShark.COLOR_VERY_DARK_GREY, label: { position: 'left', value: _this.props.xLabel, offset: 20 }, domain: _this.props.xDomain, allowDecimals: false, tick: (0, jsx_runtime_1.jsx)(CustomTick_1.CustomTickWrapper, { data: _this.props.xCustomTick }) }), (0, jsx_runtime_1.jsx)(recharts_1.YAxis, { dataKey: "yValue", type: "category", stroke: BarChartShark.COLOR_VERY_DARK_GREY, width: _this.props.yAxisWidth, tickMargin: 5, domain: _this.props.yDomain }), (0, jsx_runtime_1.jsx)(recharts_1.Tooltip, { cursor: false, content: (0, jsx_runtime_1.jsx)(CustomTooltip_1.CustomTooltipWrapper, {}) }), (0, jsx_runtime_1.jsxs)(recharts_1.Bar, __assign({ dataKey: "xValue", barSize: 40 }, { children: [_this.props.data.map(function (elem, index) { return ((0, jsx_runtime_1.jsx)(recharts_1.Cell, { fill: elem.color }, "cell-".concat(index))); }), (0, jsx_runtime_1.jsx)(recharts_1.LabelList, { className: "label-list", dataKey: "labelInfo", position: "inside" }, "label-list")] }))] })) }))); };
        _this.renderHorizontalBarChart = function () { return ((0, jsx_runtime_1.jsx)(recharts_1.ResponsiveContainer, __assign({ width: "100%", height: _this.props.chartHeight, className: "bar-chart" }, { children: (0, jsx_runtime_1.jsxs)(recharts_1.BarChart, __assign({ layout: "horizontal", data: _this.props.data }, { children: [(0, jsx_runtime_1.jsx)(recharts_1.CartesianGrid, { vertical: false, stroke: BarChartShark.COLOR_VERY_DARK_GREY }), (0, jsx_runtime_1.jsx)(recharts_1.XAxis, { dataKey: "xValue", stroke: BarChartShark.COLOR_VERY_DARK_GREY, type: "category", domain: _this.props.xDomain }), (0, jsx_runtime_1.jsx)(recharts_1.YAxis, { type: "number", stroke: BarChartShark.COLOR_VERY_DARK_GREY, domain: _this.props.yDomain, allowDecimals: false }), (0, jsx_runtime_1.jsxs)(recharts_1.Bar, __assign({ dataKey: "yValue", barSize: 40 }, { children: [_this.props.data.map(function (elem, index) { return ((0, jsx_runtime_1.jsx)(recharts_1.Cell, { fill: elem.color }, "cell-".concat(index))); }), (0, jsx_runtime_1.jsx)(recharts_1.LabelList, { className: "label-list", dataKey: "labelInfo", position: "inside" }, "label-list")] }))] })) }))); };
        return _this;
    }
    BarChartShark.prototype.render = function () {
        return this.props.layout === 'vertical' ? this.renderVerticalBarChart() : this.renderHorizontalBarChart();
    };
    BarChartShark.COLOR_VERY_DARK_GREY = '#505050';
    return BarChartShark;
}(React.PureComponent));
exports.BarChartShark = BarChartShark;
//# sourceMappingURL=BarChart.js.map